import { ArrowRight, Play } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "./Reveal";
import { RevoraCard } from "./RevoraCard";

export const FinalCta = () => {
  const navigate = useNavigate();
  return (
    <section className="bg-ink text-white py-32 sm:py-44 relative noise overflow-hidden" data-testid="final-cta">
      <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-volt/15 blur-3xl rounded-full pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-8">
            <Reveal>
              <h2 className="rvr-title font-display font-black tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-7xl">
                Make the next review <span className="text-volt">one tap away.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-8 text-white/55 text-lg max-w-md leading-relaxed">
                Give your customers a simple way to reach your Google review page.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-4">
                <button
                  data-testid="final-cta-primary"
                  onClick={() => navigate("/order?pkg=cards-100")}
                  className="group inline-flex items-center gap-3 bg-volt text-ink font-bold px-8 py-4 rounded-full hover:bg-voltdark hover:text-white transition-colors duration-300"
                >
                  Get Your Revora Products
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1.5 transition-transform duration-300" />
                </button>
                <button
                  data-testid="final-cta-secondary"
                  onClick={() => document.querySelector("#how-it-works")?.scrollIntoView({ behavior: "smooth" })}
                  className="inline-flex items-center gap-3 border border-white/25 text-white font-bold px-8 py-4 rounded-full hover:border-white transition-colors duration-300"
                >
                  <Play className="w-4 h-4 fill-white" />
                  See How It Works
                </button>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.25} className="lg:col-span-4 hidden lg:flex justify-center">
            <RevoraCard className="w-[300px] rotate-6" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
